import CybsDivider from '@cybs-ui/components/lib/divider';
import { StructFlex } from '@cybs-ui/components/lib/struct-flex';
import React from 'react';
import { connect } from 'react-redux';


class ColumnDivider extends React.Component
{

   render()
   {
   
       return(
                <StructFlex direction="column">
                    <CybsDivider dataTest="divider-inside-card" />
                </StructFlex>
       );

    }
}
function mapStateToProps(state){
   
}

export default connect(mapStateToProps)(ColumnDivider);